module.exports = __webpack_public_path__ + "static/profile_pic-923423acb655e8cd7ecc24acdec9835b.jpg";